import { mount } from "svelte";
import "./epfl.css";
import App from "./App.svelte";
import { finishLogin } from "../api/auth";
import "../api/linkTargets";

async function bootstrap() {
  // Web target only: complete the OIDC redirect before mounting. Entra returns
  // the user to /auth/callback?code=…&state=…; finish the exchange (which saves
  // the session to IndexedDB, where App.init() picks it up), then strip the
  // params so a reload doesn't replay a now-consumed code. Tree-shaken out of
  // the extension build, where the driver resolves the flow inline instead.
  if (__PLATFORM__ === "web") {
    const params = new URLSearchParams(location.search);
    // Silent renewal (prompt=none) loads this same callback page in a hidden
    // iframe: hand the URL to the opener and stop — the app must not boot a
    // second time inside the frame, and finishLogin() runs up there where the
    // PKCE stash lives.
    if (window.parent !== window && (params.has("code") || params.has("error"))) {
      window.parent.postMessage(
        { type: "oidc-silent-callback", url: location.href },
        location.origin,
      );
      return;
    }
    if (params.has("code") || params.has("error")) {
      try {
        await finishLogin(location.href);
      } catch (err) {
        console.error("OIDC callback failed", err);
      }
      // The v2 and v3 shells (/v2/, /v3/) leave their path here before
      // redirecting to Entra, since the registered redirect_uri is this same
      // /auth/callback.
      let back = "/";
      try {
        const returnTo = sessionStorage.getItem("app.returnTo");
        if (returnTo === "/v2/" || returnTo === "/v3/") back = returnTo;
      } catch {
        /* storage blocked: stay on v1 */
      }
      if (back !== "/") {
        location.replace(`${location.origin}${back}`);
        return;
      }
      history.replaceState(null, "", `${location.origin}/`);
    } else {
      // Plain v1 visit: forget any stale v2 return note.
      try {
        sessionStorage.removeItem("app.returnTo");
      } catch {
        /* ignore */
      }
    }
  }

  const target = document.getElementById("app");
  if (!target) throw new Error("#app root missing");
  mount(App, { target });
}

// No top-level await: keeps the bundle compatible with the default build
// target across both the extension and web configs.
void bootstrap();
